histories-updated
  span.label.label-sm(class="{opts.label-klass ? opts.label-klass : 'label-success'}" style="{opts.labelStyle}") {opts.locale.labels[opts.scope]}{ opts.label }
  shared-raw.one(content="{opts.getter(this.opts.json[opts.scope][1])}")
  span.feather.icon-arrow-left.mr-1.ml-1
  shared-raw.zero(content="{opts.getter(this.opts.json[opts.scope][0])}")
  script(type="typescript").
    this.mixin('histories.base');
  style(scoped).
    shared-raw.one span.d,
    shared-raw.one span.a {
      color: #006eff;
    }
    shared-raw.zero span.d,
    shared-raw.zero span.a {
      text-decoration: line-through;
      color: #FF0000;
    }
    shared-raw.zero{
      color: #888;
    }
    .icon-arrow-left {
      color: #666;
    }
